module.exports = __webpack_public_path__ + "tables4.webp?928d4e46d50ab30fcb63d214f36acafa";